/** @jsx jsx */
import { jsx } from '@emotion/core'
import { useState, useMemo, useCallback } from 'react'
import { Cascader } from 'antd'
import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getUtilities,
  getUnits,
} from 'core/selectors'
import { connect } from 'react-redux'
import R from 'ramda'

export const UtilityUnitSelection = ({
  utility,
  unit,
  utilityNameMap,
  unitNameMap,
  utilityUnitMap,
  onUnitChange,
  utilities,
  units,
  unitfilter = _ => true,
  casStyle = {},
  disabled = false,
  ...etcProps
}) => {
  const filterUnits = units.filter(unitfilter)

  const utilityIds = useMemo(_ => (utilities || []).map(u => u.utility), [
    utilities,
  ])
  const utilitysortOpt = useCallback(
    (a, b) => (utilityNameMap[a] || a).localeCompare(utilityNameMap[b] || b),
    [utilityNameMap]
  )
  const unitsortOpt = useCallback(
    (a, b) => (unitNameMap[a] || '').localeCompare(unitNameMap[b]),
    [unitNameMap]
  )
  const activeUnits = useMemo(_ => filterUnits.map(u => u.unitId), [
    filterUnits,
  ])

  const [defValue, setValue] = useState(unit == null ? [] : [utility, unit])

  let cascaderOptions = useMemo(
    _ =>
      R.sort(utilitysortOpt, Object.keys(utilityUnitMap))
        // .sort((a, b) => utilityNameMap[a].localeCompare(utilityNameMap[b]))
        .filter(k => utilityIds.includes(k))
        .map(ut => {
          const children = R.sort(unitsortOpt, utilityUnitMap[ut] || [])
            .filter(u => activeUnits.includes(u))
            .map(un => ({
              value: un,
              label: unitNameMap[un] + ' ( ' + un.substring(3) + ' )',
            }))
          return {
            value: ut,
            label: utilityNameMap[ut] + ' (' + ut + ')',
            children,
            disabled: children.length <= 0,
          }
        }),
    [
      activeUnits,
      unitNameMap,
      unitsortOpt,
      utilityIds,
      utilityNameMap,
      utilityUnitMap,
      utilitysortOpt,
    ]
  )
  const allCas = useMemo(
    _ => {
      return {
        label: 'ALL',
        value: 'ALL',
        children: R.sort(unitsortOpt, activeUnits || [])
          .filter(k => utilityIds.includes(k.substring(0, 3)))
          .map(u => ({
            value: u,
            label: unitNameMap[u] + ' (' + u.substring(3) + ')',
          })),
      }
    },
    [activeUnits, unitNameMap, unitsortOpt, utilityIds]
  )

  cascaderOptions = useMemo(_ => [allCas, ...cascaderOptions], [
    allCas,
    cascaderOptions,
  ])

  return (
    <Cascader
      defaultValue={defValue}
      value={unit == null ? [] : defValue}
      style={{ width: '90%', alignSelf: 'center', ...casStyle }}
      options={cascaderOptions}
      onChange={value => {
        setValue(value)
        if (value[0] === 'ALL')
          onUnitChange([value[1].substring(0, 3), value[1]])
        else onUnitChange(value)
      }}
      allowClear={false}
      disabled={disabled}
      {...etcProps}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  utilities: getUtilities(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(UtilityUnitSelection)
